var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flowy-drag-handle',[_c('b-button',{staticClass:"is-left",attrs:{"expanded":"","size":"is-medium"}},[_vm._v("\n        "+_vm._s(_vm.title)+".\n        "+_vm._s(_vm.description)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }